<script setup lang="ts">
import { Ref, ref } from "vue";
import { useI18n } from "vue-i18n";
import { titleInputRules } from "@/ui/validation/validationRules";
import { useApiClient } from "@/api/client";
import { toastApiResult } from "@/toaster";
import router from "@/router/router";
import CreateDashboardExportScheduleDTO = App.Data.ExportScheduler.CreateDashboardExportScheduleDTO;
const isDialogVisible = defineModel<boolean>();

const { t } = useI18n();

const { dashboard_uuid } = defineProps<{
	dashboard_uuid: string;
}>();

const scheduleToSave: Ref<CreateDashboardExportScheduleDTO> = ref({
	title: "",
	dashboard_uuid: dashboard_uuid,
});

const isFormValid: Ref<boolean> = ref(false);

const createSchedule = async () => {
	const response = await toastApiResult(
		useApiClient("exportSchedules").createFromDashboardBuilder(
			scheduleToSave.value
		)
	);
	if (response.isOk()) {
		isDialogVisible.value = false;
		router.push(`/scheduler/${response.value.uuid}`);
	}
};
</script>

<template>
	<v-dialog v-model="isDialogVisible" persistent width="60vw">
		<v-form v-model="isFormValid">
			<v-card elevation="9" class="help">
				<v-toolbar>
					<v-toolbar-title
						><i class="fa-duotone fa-calendar-clock fa-xl mr-3"></i>New
						scheduled export
					</v-toolbar-title>
					<v-spacer></v-spacer>

					<v-btn icon @click="isDialogVisible = false">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-toolbar>

				<v-divider style="border-color: unset !important" />
				<div class="pa-5">
					<div class="pa-2">
						<h6 class="text-h6 mb-3">Title:</h6>
						<v-text-field
							hide-details="auto"
							:min-width="200"
							variant="filled"
							placeholder="Title name"
							v-model="scheduleToSave.title"
							:rules="titleInputRules(t)"
						/>
					</div>
				</div>

				<v-divider style="border-color: unset !important"></v-divider>

				<v-card-actions class="mx-5 my-2">
					<v-spacer></v-spacer>
					<v-btn
						text="Cancel"
						variant="text"
						@click="isDialogVisible = false"
					></v-btn>
					<v-btn
						color="teal"
						text="Next"
						variant="tonal"
						@click="createSchedule()"
						:disabled="isFormValid === false"
					></v-btn>
				</v-card-actions>
			</v-card>
		</v-form>
	</v-dialog>
</template>

<style lang="scss"></style>
